const toastGap = "xxsmall";
const toastWidth = "xsmall";
export {
  toastGap,
  toastWidth
};
